import { gql } from "apollo-boost"

export const IMPLEMENTER_WITH_SUBMISSIONS_BY_ID = gql`
    query ImplementerById($id: ID) {
        Implementer:ImplementerWithSubmissions(implementerId: $id) {
            id
            type
            name
            director
            rfc
            commercialName
            commercialAddress
            fiscalAddress
            phone
            proofOfCharitableContributions
            legalRepresentative
            email
            mission
            vision
            history
            institutionalExperience
            previousSupports
            alliances
            incomesAndExpenses
            socialObject
            councilMembers {
                modifiedAt
                name
                email
                phone
                documents{
                    id
                    name
                    url
                }
                charge
                remuneration
                email
                phone
                documents {
                    id
                    name
                    url
                }
            }
            documents {
                id
                name
                type
                url
            }
            projects {
                name
                objective
                year
                financing {
                    id
                    type
                    institution
                    amount
                }
            }
            annualBudgets {
                id
                year
                private
                public
                own
                total
                auditedFinancials
                documents {
                    type
                    name
                    url
                }
            }
            submissions {
                id
                name
                agreementNumber
                budgeted
                state
                startDate
                endDate
            }
        }
    }
`
